import { Loader } from "@/components/ui/loader";
import {
  GOOGLE_MAP_ID,
  GOOGLE_PLACES_API_KEY,
  MAP_LIBRARIES,
} from "@/config/google";
import { LatLng } from "@/lib/types/driver-location";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import React from "react";
import { StyleSheet, View } from "react-native";
import { AdvancedMarker } from "./advanced-marker.web";
import type { NearbyDriverMarker } from "./search-map";

interface SearchMapProps {
  mapRef: React.RefObject<google.maps.Map | null>;
  pickupLocation?: LatLng | null;
  nearbyDrivers?: NearbyDriverMarker[];
  style?: object;
}

export const SearchMap: React.FC<SearchMapProps> = ({
  mapRef,
  pickupLocation,
  nearbyDrivers = [],
  style,
}) => {
  const pickupLat = Number(pickupLocation?.latitude);
  const pickupLng = Number(pickupLocation?.longitude);

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_PLACES_API_KEY,
    libraries: MAP_LIBRARIES as never[],
  });

  if (loadError) {
    return <View style={[styles.container, style]} />;
  }

  if (!isLoaded) {
    return (
      <View style={[styles.container, style]}>
        <Loader />
      </View>
    );
  }

  return (
    <View style={[styles.container, style]}>
      <GoogleMap
        onLoad={(map) => {
          if (mapRef) {
            (mapRef as React.MutableRefObject<google.maps.Map | null>).current =
              map;
          }
        }}
        mapContainerStyle={styles.map}
        center={{ lat: pickupLat, lng: pickupLng }}
        zoom={9}
        options={{
          mapId: GOOGLE_MAP_ID,
          colorScheme: "DARK",
          disableDefaultUI: true,
          keyboardShortcuts: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        <AdvancedMarker
          iconUrl="https://maps.google.com/mapfiles/ms/icons/green-dot.png"
          position={{ lat: pickupLat, lng: pickupLng }}
        />
        {nearbyDrivers.map((driver) => (
          <AdvancedMarker
            key={driver.driver_id}
            position={{
              lat: Number(driver.latitude),
              lng: Number(driver.longitude),
            }}
            iconUrl="https://maps.google.com/mapfiles/ms/icons/truck.png"
          />
        ))}
      </GoogleMap>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#0b1120",
  },
  map: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
});
